export const formatCombo = (value: string) => value.replace(/>/g, '→')
